export default "__VITE_ASSET__C6n298bx__"